// import React from "react";
// import { Container, Row, Col } from "react-bootstrap";
// import IndirectTaxHeroImg from "../../asset/Accounting.png";   // Hero background image (replace if needed)
// import IndirectTaxCenterImg from "../../asset/image1.png";     // Center image for Indirect Taxation
// import IndirectTaxRightImg from "../../asset/image5.png";      // Right-side image for services section
// import LineImg from "../../asset/line1.png";                   // Line image
// import pointImg from "../../asset/point.png";                  // Icon for points
// import "./ServiceBusiness.css";                     // Create or reuse existing CSS

// const ServiceIndirectTaxation = () => {
//   return (
//     <div>
//       {/* Hero Section */}
//       <div
//         className="services-hero"
//         style={{
//           backgroundImage: `url(${IndirectTaxHeroImg})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           height: "88vh",
//           position: "relative",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           textAlign: "center",
//         }}
//       >
//         {/* Dark Overlay */}
//         <div className="services-overlay"></div>
      
//         {/* Hero Content */}
//         <div className="services-content">
//           <h1 className="services-heading">Building Trust Through Transparency</h1>
//           <p className="services-paragraph">
//             We deliver through audits and assurance services that enhance credibility,
//             accuracy and confidence for your stakeholders.
//           </p>
//         </div>
//       </div>

//       {/* Indirect Taxation Image Section */}
//       <div className="detail-section">
//         <Container className="text-center">
//           <div className="d-flex align-items-center justify-content-center flex-wrap">
//             <img src={LineImg} alt="line-left" className="side-line" />

//             <div className="center-image-wrapper">
//               {/* <img
//                 src={IndirectTaxCenterImg}
//                 alt="Indirect Taxation Services"
//                 className="side-image"
//               /> */}
//               <div className="image-text">Indirect Taxation </div>
//             </div>

//             <img src={LineImg} alt="line-right" className="side-line mirrored" />
//           </div>
//         </Container>
//       </div>

//       {/* Service Points Section */}
//       <div className="service-image-section">
//         <Container>
//           <Row className="align-items-center">
//             {/* Left Column with Points */}
//             <Col md={6}>
//               <ul className="service-points">
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   GST Registration & Compliance 
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   GST Consulting, Advisory & Tax Planning
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   GST Return Filing & Appeals
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Central Excise, VAT,Service Tax & Customs(Legacy Matters)
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   CENVAT Consultancy
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Liaison with Authorities
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Representation before GST/Tax Authorities including Tribunal for Assessments & Certificates
//                 </li>
                
//               </ul>
//             </Col>

//             {/* Right Column with Image */}
//             <Col md={6} className="text-center text-md-end">
//               <img
//                 src={IndirectTaxRightImg}
//                 alt="Indirect Taxation Detail"
//                 className="service-right-image"
//               />
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </div>
//   );
// };

// export default ServiceIndirectTaxation;
 
import React, { memo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import IndirectTaxRightImg from "../../asset/indirecttax.webp"; // Right-side image
import LineImg from "../../asset/line1.png";              // Decorative line
import indirectImg from "../../asset/Accounting.webp";
import pointImg from "../../asset/point.png";             // Icon for points
import "./ServiceBusiness.css";

// ✅ Memoized service point component
const ServicePoint = memo(({ text }) => (
  <li>
    <img src={pointImg} alt="icon" className="point-icon" loading="lazy" />
    {text}
  </li>
));

const ServiceIndirectTaxation = () => {
  const servicePoints = [
    "GST Registration & Compliance",
    "GST Consulting, Advisory & Tax Planning",
    "GST Return Filing & Appeals",
    "Central Excise, VAT, Service Tax & Customs (Legacy Matters)",
    "CENVAT Consultancy",
    "Liaison with Authorities",
    "Representation before GST/Tax Authorities including Tribunal for Assessments & Certificates",
  ];

  return (
    <div>
      {/* Hero Section */}
      <div className="services-hero indirect-tax-hero"
       style={{
    backgroundImage: `url(${ indirectImg })`, // ✅ Use template literal with imported image
  }}
      >
        <div className="services-overlay"></div>
        <div className="services-content">
          <h1 className="services-heading">Building Trust Through Transparency</h1>
          <p className="services-paragraph">
            We deliver through indirect taxation services that enhance credibility,
            accuracy, and confidence for your stakeholders.
          </p>
        </div>
      </div>

      {/* Center Section */}
      <div className="detail-section">
        <Container className="text-center">
          <div className="d-flex align-items-center justify-content-center flex-wrap">
            <img src={LineImg} alt="line-left" className="side-line" loading="lazy" />
            <div className="center-image-wrapper">
              <div className="image-text">Indirect Taxation</div>
            </div>
            <img src={LineImg} alt="line-right" className="side-line mirrored" loading="lazy" />
          </div>
        </Container>
      </div>

      {/* Service Points Section */}
      <div className="service-image-section">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <ul className="service-points">
                {servicePoints.map((point, index) => (
                  <ServicePoint key={index} text={point} />
                ))}
              </ul>
            </Col>

            <Col md={6} className="text-center text-md-end">
              <img
                src={IndirectTaxRightImg}
                alt="Indirect Taxation Detail"
                className="service-right-image"
                loading="lazy"
              />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default memo(ServiceIndirectTaxation);
